<!-- 模板页面右侧创建编辑 -->
<template>
  <div class="TemplatePageRight">
    <div
      v-if="!templateBlank"
      class="CreateWrap">
      <div class="CreateWrapTop">
        <div
          class="CreateBlank"
          @click="openTemplateBlank">
          <div class="addicon">
            <i class="iconfont icon-add"></i>
          </div>
          <div class="hint">
            <p>{{ $t('lang.emptyDocument') }}</p>
          </div>
        </div>
        <div
          class="CreateDocument"
          @click="openUpload">
          <div class="addWrap">
            <div class="top">
              <i class="iconfont icon-add"></i>
              <div class="lineWrap">
                <div
                  class="line"
                  v-for="index in 3"
                  :key="index"></div>
              </div>
            </div>
            <div class="bottom">
              <div
                class="line"
                v-for="index in 4"
                :key="index"></div>
            </div>
          </div>
          <div class="hint">
            <!-- <p>{{ $t('lang.create') }}</p> -->
            <p>{{ $t('lang.byFiles') }}</p>
          </div>
        </div>
      </div>
      <div class="CreateWrapBottom">
        <el-button
          class="cancel"
          @click="closeProgramTemplate">
          {{ $t('lang.cancel') }}
        </el-button>
      </div>
    </div>
    <template-form
      :info="info"
      @closeProgramTemplate="closeProgramTemplate"
      v-else></template-form>
    <creat-program-tem
      v-if="dialogInfo.show"
      :info="dialogInfo"></creat-program-tem>
  </div>
</template>

<script>
import Outil from '@/assets/js/utils.js'
import creatProgramTem from './dialog/creatProgramTem'
import templateForm from './templateForm'
import Bus from '@/assets/js/vueBus.js'
import { mapState } from 'vuex'
import NotManyEdit from '@/assets/js/NotManyEdit.js'
export default {
  data () {
    return {
      templateBlank: false,
      info: {
        type: 'add',
        tag: 'tem',
        data: {}
      },
      dialogInfo: {
        show: false,
        tag: 'tem'
      }
    }
  },
  components: {
    templateForm,
    creatProgramTem
  },
  computed: {
    ...mapState({
      State: (state) => state
    })
  },
  watch: {
    // 行为同步
    'State.BehaviorChange' (data) {
      if (typeof data != 'object') {
        return
      }
      if (data.action == 'userEditUnLock' && data.type == 1) {
        const userId = localStorage.getItem('userId')
        if (userId == data.userId) {
          NotManyEdit.ReleaseHint(Outil.getProgramReceiver('ownerEmail'), this.closeProgramTemplate)
        }
      }
    }
  },
  created () {
    Bus.$on('openCreatDialog', (obj) => {
      this.dialogInfo.show = obj.show
    })
  },
  mounted () {
    window.addEventListener('unload', this.EditSend)
    Bus.$on('goTemplateBlank', (obj, flag) => {
      this.templateBlank = flag
      if (this.info.data && this.info.data.id) {
        this.EditSend('close')
      }
      this.info = JSON.parse(JSON.stringify(obj))
      this.EditSend('add')
    })
    if (this.$route.query.type) {
      this.openTemplateBlank()
    }
  },
  methods: {
    // 在编辑add、取消编辑close,浏览器关闭 空
    EditSend (type) {
      if (!this.info.data.id) {
        return
      }
      const param = {
        logicId: this.info.data.id,
        type: 1
      }
      if (type == 'add') {
        param.pid = this.$BehaviorSyns.getProgramId()
        param.name = this.info.data.templateName
        NotManyEdit.AddEdit(param)
      } else if (type == 'close') {
        NotManyEdit.QuitEdit(param)
      } else {
        NotManyEdit.CloseQuitEdit(param)
      }
    },
    closeProgramTemplate () {
      this.$emit('closeProgramTemplate')
    },
    openUpload () {
      this.dialogInfo.show = true
    },
    openTemplateBlank () {
      this.info.type = 'add'
      this.templateBlank = true
    }
  },
  beforeDestroy () {
    Bus.$off('goTemplateBlank')
    this.EditSend('close')
    window.removeEventListener('unload', this.EditSend)
  }
}
</script>

<style scoped lang="less">
.TemplatePageRight {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #252525;
  .CreateWrap {
    width: 100%;
    height: 100%;
    padding: 40px 0 0 64px;
    .CreateWrapTop{
      height: 92%;
      display: flex;
      .CreateBlank {
        width: 160px;
        height: 240px;
        background: #d8d8d8;
        border: 1px solid #979797;
        .addicon {
          height: 165px;
          text-align: center;
          line-height: 165px;
          i {
            font-size: 23px;
            color: #252525;
          }
        }
        .hint {
          width: 122px;
          height: 51px;
          font-size: 14px;
          font-weight: bold;
          color: #252525;
          line-height: 17px;
          text-align: left;
          margin-left: 19px;
          p {
            line-height: 17px;
            margin: 0;
          }
        }
      }
      .CreateDocument {
        width: 160px;
        height: 240px;
        background: #d8d8d8;
        border: 1px solid #979797;
        margin-left: 64px;
        .addWrap {
          width: 88px;
          height: 60px;
          margin: 60px auto 42px;
          .top {
            display: flex;
            align-items: center;
            i {
              font-size: 23px;
              color: #252525;
            }
            .lineWrap {
              margin-left: 13px;
              .line {
                width: 52px;
                height: 3px;
                background: #252525;
                border-radius: 2px;
                margin-bottom: 7px;
              }
            }
          }
          .bottom {
            .line {
              width: 88px;
              height: 3px;
              background: #252525;
              border-radius: 2px;
              margin-bottom: 7px;
            }
          }
        }
        .hint {
          width: 122px;
          height: 34px;
          font-size: 14px;
          font-weight: bold;
          color: #252525;
          line-height: 17px;
          margin-left: 19px;
          p {
            line-height: 17px;
            margin: 0;
          }
        }
      }
    }
    .CreateWrapBottom{
      text-align: right;
      padding-right: 100px;
      .el-button{
            padding: 7px 20px;
            &.black{
                margin-right: 50px;
                border: 1px solid #524C4C;
            }
        }
    }
  }
}
</style>
